import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-deliverycmd',
  templateUrl: './deliverycmd.component.html',
  styleUrls: ['./deliverycmd.component.scss']
})
export class DeliverycmdComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
